export const CLEAR_PERMIT_APPLICATION_ERROR = 'CLEAR_PERMIT_APPLICATION_ERROR';

export const PERMITS_LOADING_SUCCESS = 'PERMITS_LOADING_SUCCESS';

export const CHANGE_PERMIT_STEP = 'CHANGE_PERMIT_STEP';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const PERMIT_CANCEL_APPLICATION = 'PERMIT_CANCEL_APPLICATION';
export const PERMIT_CANCEL_APPLICATION_SUCCESS = 'PERMIT_CANCEL_APPLICATION_SUCCESS';
export const PERMIT_CANCEL_APPLICATION_ERROR = 'PERMIT_CANCEL_APPLICATION_ERROR';

export const PERMITS_ERROR = 'PERMITS_ERROR';
export const PERMITS_LOADING = 'PERMITS_LOADING';

export const INITIATE_PERMITS_APPLICATION = 'INITIATE_PERMITS_APPLICATION';
export const INITIATE_PERMITS_APPLICATION_SUCCESS = 'INITIATE_PERMITS_APPLICATION_SUCCESS';
export const PERMIT_LOADING_SUCCESS = 'PERMIT_LOADING_SUCCESS';
export const FETCH_APPLICATION_PERMITS_SUCCESS = 'FETCH_APPLICATION_PERMITS_SUCCESS';

export const RESET_PERMITS_ERROR = 'RESET_PERMITS_ERROR';
export const UPDATE_PERMIT_STATE = 'UPDATE_PERMIT_STATE';
export const UPDATE_PERMIT_STATE_BY_KEY_VALUE = 'UPDATE_PERMIT_STATE_BY_KEY_VALUE';
export const RESET_PERMITS_DETAILS = 'RESET_PERMITS_DETAILS';
